<template>
    <div class="components-container">
        <!-- 操作区域 -->
        <div class="filter-container">
            <el-select v-model="queryForm.year" placeholder="学年" style="width:180px;" @change="handleFilter">
                <el-option v-for="(item, index) in comboOption.year" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            <el-input v-model="queryForm.courseName" placeholder="课程名称" style="width:180px;"></el-input>
            <el-select v-model="queryForm.deptCode" placeholder="开课系部" style="width:180px;" clearable>
                <el-option v-for="(item, index) in comboOption.courseDept" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>
            <el-select v-model="queryForm.semesterNum" placeholder="修读学期" style="width:180px;" clearable>
                <el-option v-for="(item, index) in comboOption.semesterNum" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                </el-option>
            </el-select>

            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="addCourse" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;添加</el-button>
            <el-button @click="delCourse" type="danger"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
            <!-- <el-button @click="inheritCourse" type="primary"><i class="el-icon-document-copy"></i>&nbsp;继承</el-button> -->
        </div>

        <!-- 列表区域 -->
        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            element-loading-text="信息加载中" stripe border fit highlight-current-row header-cell-class-name="tableHeadStyle"
            :height="mainTableHeight" ref="mainTable">
            <el-table-column type="selection" width="50" align="center"></el-table-column>
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="学年" prop="year" width="100px" align="center"></el-table-column>
            <el-table-column label="课程名称" prop="courseName" align="center"></el-table-column>
            <el-table-column label="开课部门" prop="deptName" width="150px" align="center"></el-table-column>
            <el-table-column label="学分" prop="credit" width="50px" align="center"></el-table-column>
            <el-table-column label="修读学期" prop="semesterNum" :formatter="semesterNumFormatter" width="80px" align="center"></el-table-column>
            <el-table-column label="修读学时" prop="semesterLearnHour" width="50px" align="center"></el-table-column>
            <el-table-column label="设置专业" prop="majorNum" width="50px" align="center"></el-table-column>
            <el-table-column label="已用专业" prop="usedMajorNum" width="50px" align="center"></el-table-column>
            <el-table-column label="操作" width="210px" align="center">
                <template slot-scope="scope">
                    <el-button type="warning" size="small" @click="modCourse(scope.row)">
                        <i class="el-icon-edit"></i>&nbsp;编辑
                    </el-button>
                    <el-button type="primary" size="small" @click="majorConfig(scope.row)">
                        <i class="el-icon-setting"></i>&nbsp;专业设置
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="800px" top="150px" append-to-body>
            <el-form ref="curdForm" :model="curdForm" label-width="120px" label-position="left" :rules="curdFormRules">
                <el-form-item label="课程名称" prop="courseComboValue">
                    <el-select v-model="curdForm.courseComboValue" placeholder="请选择" style="width:100%;" @change="handleCourseChange" filterable>
                        <el-option v-for="(item, index) in comboOption.course" :key="item.value" :value="item.value" :label="item.label">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="学年" prop="year">
                            <el-select v-model="curdForm.year" placeholder="请选择" style="width:100%;">
                                <el-option v-for="(item, index) in comboOption.year" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="考核方式" prop="examTypeCode">
                            <el-select v-model="curdForm.examTypeCode" placeholder="请选择" style="width:100%;">
                                <el-option v-for="(item, index) in comboOption.examType" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="学分" prop="credit">
                            <el-input-number v-model="curdForm.credit" style="width:100%;" :min="0" :max="999" :precision="2" :step="1" label="请输入学分"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="总学时" prop="totalHour">
                            <el-input-number v-model="curdForm.totalHour" style="width:100%;" :min="0" :max="999" label="请输入总学时">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="理论学时" prop="theoryHour">
                            <el-input-number v-model="curdForm.theoryHour" style="width:100%;" :min="0" :max="999" label="请输入理论学时">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="实践学时" prop="trainingHour">
                            <el-input-number v-model="curdForm.trainingHour" style="width:100%;" :min="0" :max="999" label="请输入实践学时">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="修读学期" prop="semesterNum">
                            <el-select v-model="curdForm.semesterNum" placeholder="请选择" style="width:100%;">
                                <el-option v-for="(item, index) in comboOption.semesterNum" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="修读学时" prop="semesterLearnHour">
                            <el-input-number v-model="curdForm.semesterLearnHour" style="width:100%;" :min="0" :max="999" label="请输入修读学时">
                            </el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button type="primary" @click="saveCourse">确定</el-button>
                <el-button @click="dialogVisible = false">取消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="继承公共课设置" :visible.sync="inheritCourseDialog" @closed="closeInheritCourseDialog" width="540px" top="20vh" append-to-body>
            <el-form :model="inheritForm" ref="inheritForm" label-width="130px" label-position="left" width="100%">
                <el-row>
                    <el-form-item label="被继承学年" prop="year">
                        <el-select v-model="inheritForm.year" placeholder="学年" style="width: 100%;" @change="termChange">
                            <el-option v-for="(item, index) in comboOption.jcyear" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="所属部门" prop="courseDept">
                        <el-select v-model="inheritForm.courseDept" placeholder="全部" style="width: 100%;" @change="ssbmChange" clearable>
                            <el-option v-for="(item, index) in comboOption.courseDept" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-row>
                    <el-form-item label="公共课" prop="course">
                        <el-select v-model="inheritForm.course" placeholder="全部" style="width:100%;" filterable multiple clearable>
                            <el-option v-for="(item, index) in comboOption.courseInfo" :key="item.comboValue" :value="item.comboValue" :label="item.comboName">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="inheritCourseSubmit" type="primary" style="margin-left: 10px;"><i class="el-icon-document">&nbsp;确定</i></el-button>
                <el-button @click="closeInheritCourseDialog" >取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="专业设置" :visible.sync="majorConfigDialogVisible" @closed="queCourseList" width="1200px" top="80px" append-to-body>
            <div style="height:600px;">
                <majorConfig ref="majorConfig" :listHeight="500"></majorConfig>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";
    import majorConfig from "./majorConfig.vue";

    export default {
        props: ['listHeight'],
        components: {
            majorConfig,
        },
        data() {
            return {
                userRole: [],
                //查询列表数据
                queryForm: {
                    year: null,
                    deptCode: null,
                    semesterNum: null,
                    courseName: null,
                },
                //下拉框选项数据
                comboOption: {
                   year: null,
                   jcyear: [],//被继承学年
                   dept: null,
                   courseDept: null,
                   course: null,
                   examType: null,
                   majorProp: null,
                   isUsed: null,
                   courseInfo: null,
                },
                semesterNumName: ["第一学期", "第二学期", "第三学期", "第四学期", "第五学期", "第六学期", "第七学期", "第八学期", "第九学期", "第十学期"],
                //表数据
                tableData: [],
                tableLoading: true,
                mainTableHeight: 500,
                selectRowData: null,
                loadingMask: null,
                dialogTitle: null,
                dialogVisible: null,
                curdForm: {
                    id: null,
                    year: null,
                    courseCode: null,
                    courseComboValue: null,
                    credit: 0,
                    totalHour: 0,
                    theoryHour: 0,
                    trainingHour: 0,
                    examTypeCode: '01',
                    semesterNum: null,
                    semesterLearnHour: 0,
                },
                curdFormRules: {
                    year: [{
                        required: true,
                        trigger: ['blur', 'change'],
                        message: "请选择学年",
                    }],
                    courseComboValue: [{
                        required: true,
                        trigger: ['blur', 'change'],
                        message: "请选择课程",
                    }],
                    examTypeCode: [{
                        required: true,
                        trigger: ['blur', 'change'],
                        message: "请选择考核方式",
                    }],
                    semesterNum: [{
                        required: true,
                        trigger: ['blur', 'change'],
                        message: "请选择修读学期",
                    }],
                },
                majorConfigDialogVisible: false,

                inheritCourseDialog: false,
                inheritForm: {
                    curyear: null,
                    year: null,
                    courseDept: null,
                    course: null,
                },
            }
        },
        mounted() {
            this.userInfo();
            this.initCombo();

            this.$nextTick().then(() => {
                if(this.listHeight){
                    this.mainTableHeight = this.listHeight;
                }else{
                    //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                    //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                    this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;
                    // 监听窗口大小变化
                    let self = this;
                    window.onresize = function() {
                        self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                    };
                }
            });
        },
        methods: {
            userInfo() {
                this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;
                    if (userInfo) {
                        for (let roleCode in userInfo.roles) {
                            // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
                            this.userRole.push(roleCode);
                        }
                    }
                }).catch((err) => {
                    console.log(err);
                });
            },
            initCombo() {
                this.$api.teachingManage.coursePreConfig.initCombo({}).then((res) => {
                    this.comboOption.year = res.data.data.yearComboData;
                    this.comboOption.dept = res.data.data.deptComboData;
                    this.comboOption.courseDept = res.data.data.courseDeptComboData;
                    this.comboOption.course = res.data.data.courseComboData;
                    this.comboOption.examType = res.data.data.examTypeComboData;
                    this.comboOption.semesterNum = res.data.data.semesterNumComboData;
                    this.comboOption.majorProp = res.data.data.majorPropComboData;
                    this.comboOption.isUsed = res.data.data.isUsedComboData;

                    this.queryForm.year = this.comboOption.year[0].comboValue;
                    this.curdForm.year = this.comboOption.year[0].comboValue;

                    this.queCourseList();
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            queCourseList() {
                this.tableLoading = true;

                this.$api.teachingManage.coursePreConfig.queCourseList({
                    data: this.queryForm,
                }).then((res) => {
                    this.tableData = res.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    showNotify('错误', error, 'error', 3000);
                });
            },
            semesterNumFormatter(row) {
                return this.semesterNumName[parseInt(row.semesterNum)-1];
            },
            //页码区域方法
            handleCurrentChange(val, old) {
                this.selectRowData = val;
            },
            handleFilter() {
                this.queCourseList();
            },
            handleReset() {
                this.queryForm.deptCode = null;
                this.queryForm.semesterNum = null;
                this.queryForm.courseName = null;
                this.queCourseList();
            },
            handleCourseChange(value){
                for(let i=0; i<this.comboOption.course.length; i++){
                    const courseInfo = this.comboOption.course[i];

                    if(value === courseInfo.value){
                        this.curdForm.courseCode = courseInfo.value.split('-')[0];
                        this.curdForm.credit = courseInfo.credit;
                        this.curdForm.totalHour = courseInfo.totalTime;
                        this.curdForm.theoryHour = courseInfo.theoryTime;
                        this.curdForm.trainingHour = courseInfo.practiseTime;
                        this.curdForm.semesterLearnHour = courseInfo.totalTime;

                        break;
                    }
                }
            },
            addCourse(){
                this.dialogTitle = '新建';
                this.dialogVisible = true;
                this.curdForm.id = null;
            },
            modCourse(rowData){
                this.dialogTitle = '编辑';
                this.dialogVisible = true;

                this.$nextTick().then(() => {
                    this.curdForm.id = rowData.id;
                    this.curdForm.year = rowData.year;
                    this.curdForm.courseCode = rowData.courseCode;
                    this.curdForm.courseComboValue = rowData.courseCode + '-' + rowData.courseName;
                    this.curdForm.credit = rowData.credit;
                    this.curdForm.totalHour = rowData.totalHour;
                    this.curdForm.theoryHour = rowData.theoryHour;
                    this.curdForm.trainingHour = rowData.trainingHour;
                    this.curdForm.examTypeCode = rowData.examTypeCode;
                    this.curdForm.semesterNum = rowData.semesterNum;
                    this.curdForm.semesterLearnHour = rowData.semesterLearnHour;
                });
            },
            saveCourse(){
                this.$refs['curdForm'].validate((valid) => {
                    if (valid) {
                        this.$api.teachingManage.coursePreConfig.saveCourseRec({
                            data: this.curdForm
                        }).then((res) => {
                            let state = res.data.data.state;
                            switch (state) {
                                case 'success':
                                    showNotify('成功', '保存成功', 'success', 1500);
                                    this.queCourseList();
                                    this.dialogVisible = false;
                                    break;
                                case 'exist':
                                    this.$alert('保存失败，课程已存在！', '提示', {
                                        confirmButtonText: '确定',
                                    });
                                    break;
                                default:
                                    showNotify('错误', '保存失败', 'error', 3000);
                                    break;
                            }
                        }).catch((error) => {
                            showNotify('错误', error, 'error', 3000);
                        });
                    } else {
                        return false;
                    }
                });
            },
            delCourse(){
                //获取选择的专业信息
                let selCourses = this.$refs.mainTable.selection;
                if(selCourses.length === 0){
                    this.$alert('请至少选择一门课程', '提示', {
                        confirmButtonText: '确定',
                    });
                    return;
                }

                let idArray = new Array();
                for(let i=0; i<selCourses.length; i++){
                    idArray.push(selCourses[i].id);
                }

                confirmMsg('是否确定要删除当前选择的课程信息').then(() => {
                    this.$api.teachingManage.coursePreConfig.delCourseRec({
                        data: {
                            ids: idArray.toString(),
                        }
                    }).then((res) => {
                        let state = res.data.data.state;
                        switch (state) {
                            case 'success':
                                showNotify('成功', '删除成功', 'success', 1500);
                                this.queCourseList();
                                break;
                            default:
                                showNotify('错误', '删除失败', 'error', 3000);
                                break;
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            closeDialog(){
                if (this.$refs['curdForm'] !== undefined) {
                    this.$refs['curdForm'].clearValidate();
                    this.$refs['curdForm'].resetFields();
                }
            },
            majorConfig(rowData){
                this.majorConfigDialogVisible = true;

                this.$nextTick().then(() => {
                    this.$refs.majorConfig.queryForm.preCourseCode = rowData.id;
                    this.$refs.majorConfig.comboOption.majorProp = this.comboOption.majorProp;
                    this.$refs.majorConfig.comboOption.dept = this.comboOption.dept;
                    this.$refs.majorConfig.comboOption.isUsed = this.comboOption.isUsed;
                    this.$refs.majorConfig.queMajorList();
                });
            },
            //继承
            inheritCourse(){
                this.comboOption.jcyear = [];
                for(let i=0;i<this.comboOption.year.length;i++){
                    if(parseInt(this.comboOption.year[i].comboValue,10)<parseInt(this.queryForm.year,10)){
                        this.comboOption.jcyear.push(this.comboOption.year[i]);
                    }
                }
                this.inheritCourseDialog = true;
            },
            closeInheritCourseDialog(){
                this.inheritCourseDialog = false;
                this.inheritForm.year = '';
                this.inheritForm.courseDept = '';
                this.inheritForm.course = [];
            },
            termChange(val){
                this.courseOption();
            },
            ssbmChange(val){
                this.courseOption();
            },
            courseOption(){
                const paramMap = {
                    'year': this.inheritForm.year,
                    'courseDept': this.inheritForm.courseDept,
                }
                this.$api.teachingManage.coursePreConfig.courseOption({
                    data: paramMap
                }).then(response => {
                    this.comboOption.courseInfo = response.data.data.courseInfo;
                }).catch(error => {
                    console.log(error);
                });
            },
            inheritCourseSubmit(){
                if(this.inheritForm.year==null || this.inheritForm.year==''){
                    this.$message({
                        type: 'warning',
                        message: '被继承学年不能为空'
                    });
                    return;
                }
            
                confirmMsg('如公共课设置信息已存在，继承前将删除本学年符合所选条件的公共课设置信息，是否确定？').then(() => {
                    this.inheritCourseConfirm();
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
            inheritCourseConfirm(){
                this.showLoadingMask("公共课设置生成中，请稍候");
            
                const paramMap = {
                    'curyear': this.queryForm.year,
                    'year': this.inheritForm.year,
                    'courseDept': this.inheritForm.courseDept,
                    'course': this.inheritForm.course+'',
                }
                this.$api.teachingManage.coursePreConfig.inheritCourseConfirm({
                    data: paramMap
                }).then(response => {
                    let state = response.data.data.state;
                    let msg = response.data.data.msg;
            
                    if (state == 'Success') {
                        this.$notify({
                            title: "成功",
                            message: msg ? msg : "保存成功",
                            type: "success",
                            duration: 1500,
                        });
            
                        this.queCourseList();
                        this.inheritCourseDialog = false;
                    }else{
                        this.$notify({
                            title: "失败",
                            message: msg ? msg : '保存失败',
                            type: "error",
                            duration: 3000,
                        });
                    }
                    this.closeLoadingMask();
                }).catch(error => {
                    this.$notify({
                        title: "错误",
                        message: error,
                        type: "error",
                        duration: 3000,
                    });
                    this.closeLoadingMask();
                });
            },
            //显示loading
            showLoadingMask(str) {
                this.loadingMask = this.$loading({
                    lock: true,
                    text: str,
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.8)",
                });
            },
            //关闭loading
            closeLoadingMask() {
                if (this.loadingMask) this.loadingMask.close();
            },
        }
    };
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// coursePreConfig.vue?6011d71a